import { Helmet } from 'react-helmet'
import { getStepNumber } from 'config/onboarding'
import { getTitle } from 'config/titles'
import Onboarding from 'components/Onboarding'
import { useNetwork } from '~/networkProvider'
import { FacilityScreenContainer } from '~/components/FacilityScreenContainer'

const OnboardingExteriorWallsScreen = () => {
  const { online } = useNetwork()
  return (
    <FacilityScreenContainer>
      <Helmet>
        <title>{getTitle('exteriorWalls')}</title>
      </Helmet>
      <Onboarding
        online={online}
        step={getStepNumber('Ext. Walls')}
        message="Draw the exterior walls of your facility."
      />
    </FacilityScreenContainer>
  )
}

export default OnboardingExteriorWallsScreen
